/* =========================================================
 * Extends bootstrap modal to resume tab & shift-tab behavior which are alerted by modal's enforceFocus.
 * Extension written for 8 Ball by Elaine
 * Script revamped by Steven Stedman
 * ========================================================= */
/* global define:true */

define([
	'jquery',
	'bootstrap-modal'
], function($) {

	'use strict';

	var _enforceFocus = $.fn.modal.Constructor.prototype.enforceFocus;

	$.fn.modal.Constructor.prototype.enforceFocus = function() {
		_enforceFocus.apply(this, arguments);

		var $el = this.$element,
			$tabables = $el.find('a, button, input, select, textarea, [tabindex=0]')
					.filter(':visible:not(:disabled)');

		$el.focus($.proxy(function() {
			$el.on('keyup.shiftTab', $.proxy(function(event) {
				if (event.which === 9) { // tab key
					if (event.shiftKey) { // + shift key
						$tabables.eq($tabables.length - 1).focus();
					} else {
						$tabables.eq(0).focus();
					}
				}
			}, this));
		}, this));

		$el.blur($.proxy(function() {
			$el.off('keyup.shiftTab');
		}, this));
	};
});



//////////////////
// WEBPACK FOOTER
// ./widgets/accessibleModal.js
// module id = 872
// module chunks = 0